import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MatSpinnerService {
  /**
   * Global circular loader in the center of the page has been removed.
   * Loading feedback is handled by localized button loading states,
   * table skeletons, and in-table indicators.
   * Methods are preserved as no-ops for backwards compatibility.
   */
  show(): void {}

  hide(): void {}

  reset(): void {}
}